'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { initHeap, trackPageView } from '../lib/heapClient';

export default function HeapClient() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    // Initialize Heap on first load
    useEffect(() => {
        initHeap();
    }, []);

    // Track page views on route changes
    useEffect(() => {
        // This will run on every route change
        trackPageView();
    }, [pathname, searchParams]);

    return null;
} 